import {putAll, showBeError, showSuccess, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';

import {adminAction, RemoveUsersFromOrganizationRoleAction} from '../action';

const tt = t('admin');

function* execute({payload: {roleId, organizationId}}: RemoveUsersFromOrganizationRoleAction): SagaIterator {
    const response = yield* call(Api.endUserProfileOrganizationRoleBindingForRole, {roleId, organizationId});

    if (response.isSuccess) {
        yield* put(adminAction.getManagementOrganizationsTableData(opt({action: 'refresh'}), organizationId));
        yield putAll(showSuccess(
            tt('removeUsersFromRole'),
            tt('removeUsersFromRoleSuccess'),
            false,
            'removeUsersFromRole',
        ));
    } else {
        yield putAll(showBeError(response, tt('removeUsersFromRole')));
    }
}

/** Runs the admin saga that removes users from the selected organization role. */
export function* removeUsersFromOrganizationRole(): SagaIterator {
    yield takeLatestF('admin/REMOVE_USERS_FROM_ORGANIZATION_ROLE', execute);
}
